import { render, staticRenderFns } from "./pedido.compra.detalles.table.vue?vue&type=template&id=78e18195&scoped=true&"
import script from "./pedido.compra.detalles.table.vue?vue&type=script&lang=js&"
export * from "./pedido.compra.detalles.table.vue?vue&type=script&lang=js&"
import style0 from "./pedido.compra.detalles.table.vue?vue&type=style&index=0&id=78e18195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e18195",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VList,VListItem,VListItemTitle,VMenu,VSnackbar})
